export const DEFAULT_AUTHENTICATED_PATH = "/projects";

export function normalizeReturnUrl(returnUrl?: string | null): string | null {
  if (!returnUrl || !returnUrl.startsWith("/")) {
    return null;
  }

  if (returnUrl.startsWith("//")) {
    return null;
  }

  if (returnUrl.startsWith("/login") || returnUrl.startsWith("/logout")) {
    return null;
  }

  return returnUrl;
}

export function getLoginRedirectPath(pathname: string, search = ""): string {
  const returnUrl = normalizeReturnUrl(`${pathname}${search}`);

  if (!returnUrl || returnUrl === "/") {
    return "/login";
  }

  const params = new URLSearchParams({ returnUrl });
  return `/login?${params.toString()}`;
}

export function getAuthPath(pathname: string, returnUrl?: string | null): string {
  const normalizedReturnUrl = normalizeReturnUrl(returnUrl);

  if (!normalizedReturnUrl || normalizedReturnUrl === "/") {
    return pathname;
  }

  const params = new URLSearchParams({ returnUrl: normalizedReturnUrl });
  return `${pathname}?${params.toString()}`;
}

export function getAuthenticatedLandingPath(returnUrl?: string | null): string {
  return normalizeReturnUrl(returnUrl) ?? DEFAULT_AUTHENTICATED_PATH;
}
